<template>
  <v-container fluid grid-list-xs>
    <v-layout row wrap>
      <v-flex xs2 class="primary--text">Name:</v-flex>
      <v-flex xs4>{{ chargeback.name }}</v-flex>

      <v-flex xs2 class="primary--text">ID:</v-flex>
      <v-flex xs4>{{ chargeback.id }}</v-flex>

      <v-flex xs2 class="primary--text">Reference Number:</v-flex>
      <v-flex xs4>{{ chargeback.reference_number }}</v-flex>

      <v-flex xs2 class="primary--text">Amount:</v-flex>
      <v-flex xs4>{{ money(chargeback.amount) }}</v-flex>

      <v-flex xs2 class="primary--text">Reason Code:</v-flex>
      <v-flex xs4>{{ money(chargeback.reason_code) }}</v-flex>

      <v-flex xs2 class="primary--text">Reason:</v-flex>
      <v-flex xs4>{{ money(chargeback.reason) }}</v-flex>

      <v-flex xs2 class="primary--text">Case Number:</v-flex>
      <v-flex xs4>{{ money(chargeback.case_number) }}</v-flex>

      <v-flex xs2 class="primary--text">Aquisition Number:</v-flex>
      <v-flex xs4>{{ money(chargeback.aquisition_number) }}</v-flex>

      <v-flex xs2 class="primary--text">Approval Code:</v-flex>
      <v-flex xs4>{{ chargeback.approval_code }}</v-flex>

      <v-flex xs2 class="primary--text">Date:</v-flex>
      <v-flex xs4>{{ datetime(user.date) }}</v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      chargeback: {}
    }
  },

  mounted () {
    this.load()
  },

  methods: {
    async load () {
      Bus.$emit('openWaitModal')

      try {
        if (!this.$route.params.id) {
          throw new Error('Invalid chargeback')
        }

        let data = await this.api({url: `/chargebacks/${this.$route.params.id}`})

        this.chargeback = data.data.chargeback
      } catch (error) {
        Bus.$emit('openModal', {status: 'error', message: error})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/Chargeback.vue